var _ColumnsButton;
import React from 'react';
import { string } from 'prop-types';
import { GridToolbarColumnsButton } from '@mui/x-data-grid-pro';
import createStyledToolbarButton from './utlils/createStyledToolbarButton';
import SovosTooltip from '../sovos-tooltip/SovosTooltip';
import useMosaicTranslation from '../internals/i18n/useMosaicTranslation';
const ColumnsButton = createStyledToolbarButton(GridToolbarColumnsButton);
const SovosDataGridToolbarColumnsButton = _ref => {
  let {
    title
  } = _ref;
  const {
    t
  } = useMosaicTranslation();
  return /*#__PURE__*/React.createElement(SovosTooltip, {
    title: title || t('toolbar.columnDrawerTooltip')
  }, _ColumnsButton || (_ColumnsButton = /*#__PURE__*/React.createElement(ColumnsButton, {
    size: "large"
  })));
};
SovosDataGridToolbarColumnsButton.propTypes = {
  title: string
};
export default SovosDataGridToolbarColumnsButton;